import classNames from 'classnames';

import styles from './LayoutContainer.module.scss';
import { LayoutContainerProps } from './LayoutContainer.types';

export function LayoutContainer({
  children,
  className,
  mods,
}: LayoutContainerProps) {
  return (
    <div
      className={classNames(
        styles.container,
        className,
        mods?.map((mod) => styles[mod]),
      )}
    >
      {children}
    </div>
  );
}
